import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const AdminsUpdateContent = lazy(() => import('../../../../components/Pages/Admins/[adminId]/Update'));

export default function AdminsUpdate(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Admin Update`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <AdminsUpdateContent />
      </Suspense>
    </Layout>
  );
}
